/* ============================================================
   TitleFinder AU — Exit Intent Popup
   "Did you find what you needed?" → directs to Quiz
   ============================================================ */
(function() {
  'use strict';

  // Only show once per session
  if (sessionStorage.getItem('tf_exit_shown')) return;

  var triggered = false;
  var delayPassed = false;

  // Wait 5 seconds before enabling (don't annoy quick visitors)
  setTimeout(function() { delayPassed = true; }, 5000);

  // Exit intent: mouse leaves viewport from top
  document.addEventListener('mouseout', function(e) {
    if (!delayPassed || triggered) return;
    if (e.clientY > 10) return; // only trigger when mouse goes to top
    if (!e.relatedTarget && !e.toElement) {
      showPopup();
    }
  });

  // Mobile: trigger on back button / scroll up fast
  var lastScrollY = window.scrollY;
  var scrollUpCount = 0;
  window.addEventListener('scroll', function() {
    if (!delayPassed || triggered) return;
    var currentY = window.scrollY;
    if (currentY < lastScrollY && currentY < 100 && lastScrollY > 300) {
      scrollUpCount++;
      if (scrollUpCount >= 2) {
        showPopup();
      }
    }
    lastScrollY = currentY;
  }, { passive: true });

  function showPopup() {
    if (triggered) return;
    triggered = true;
    sessionStorage.setItem('tf_exit_shown', '1');

    // Create overlay
    var overlay = document.createElement('div');
    overlay.id = 'tf-exit-overlay';
    overlay.innerHTML = [
      '<div id="tf-exit-popup">',
      '  <button id="tf-exit-close" aria-label="Close">&times;</button>',
      '  <div class="tf-exit-icon">🔍</div>',
      '  <h2>Did you find what you needed?</h2>',
      '  <p>Not sure which title search is right for you? Our quick quiz will match you with the perfect product in under 30 seconds.</p>',
      '  <div class="tf-exit-buttons">',
      '    <button id="tf-exit-yes" class="tf-exit-btn tf-exit-btn--secondary">Yes, I\'m good!</button>',
      '    <button id="tf-exit-no" class="tf-exit-btn tf-exit-btn--primary">Help me choose →</button>',
      '  </div>',
      '  <span class="tf-exit-note">Takes less than 30 seconds</span>',
      '</div>'
    ].join('\n');

    document.body.appendChild(overlay);

    // Animate in
    requestAnimationFrame(function() {
      overlay.classList.add('tf-exit-visible');
    });

    // Close handlers
    document.getElementById('tf-exit-close').onclick = closePopup;
    document.getElementById('tf-exit-yes').onclick = closePopup;
    document.getElementById('tf-exit-no').onclick = function() {
      closePopup();
      var quiz = document.querySelector('.tf-quiz');
      if (quiz) {
        quiz.scrollIntoView({ behavior: 'smooth', block: 'start' });
        // Flash the quiz to draw attention
        quiz.style.transition = 'box-shadow 0.3s ease';
        quiz.style.boxShadow = '0 0 0 4px rgba(0,186,219,0.4)';
        setTimeout(function() { quiz.style.boxShadow = 'none'; }, 2000);
      } else {
        // Fallback: scroll to page section or redirect
        window.location.href = '/#quiz';
      }
    };

    // Click overlay to close
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closePopup();
    });

    // Escape key
    document.addEventListener('keydown', function handler(e) {
      if (e.key === 'Escape') {
        closePopup();
        document.removeEventListener('keydown', handler);
      }
    });
  }

  function closePopup() {
    var overlay = document.getElementById('tf-exit-overlay');
    if (!overlay) return;
    overlay.classList.remove('tf-exit-visible');
    overlay.classList.add('tf-exit-hiding');
    setTimeout(function() {
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
    }, 300);
  }

  // Inject styles
  var style = document.createElement('style');
  style.textContent = [
    '#tf-exit-overlay {',
    '  position: fixed; inset: 0; z-index: 999999;',
    '  background: rgba(10, 61, 92, 0.6);',
    '  backdrop-filter: blur(4px); -webkit-backdrop-filter: blur(4px);',
    '  display: flex; align-items: center; justify-content: center;',
    '  padding: 20px;',
    '  opacity: 0; transition: opacity 0.3s ease;',
    '}',
    '#tf-exit-overlay.tf-exit-visible { opacity: 1; }',
    '#tf-exit-overlay.tf-exit-hiding { opacity: 0; }',
    '',
    '#tf-exit-popup {',
    '  background: #ffffff; border-radius: 20px;',
    '  padding: 40px 36px 32px; max-width: 440px; width: 100%;',
    '  text-align: center; position: relative;',
    '  box-shadow: 0 25px 60px rgba(0,0,0,0.25);',
    '  transform: translateY(20px) scale(0.95);',
    '  animation: tfPopIn 0.35s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;',
    '}',
    '@keyframes tfPopIn {',
    '  to { transform: translateY(0) scale(1); }',
    '}',
    '#tf-exit-overlay.tf-exit-hiding #tf-exit-popup {',
    '  animation: tfPopOut 0.25s ease forwards;',
    '}',
    '@keyframes tfPopOut {',
    '  to { transform: translateY(20px) scale(0.95); opacity: 0; }',
    '}',
    '',
    '#tf-exit-close {',
    '  position: absolute; top: 14px; right: 14px;',
    '  background: #f1f5f9; border: none; border-radius: 50%;',
    '  width: 36px; height: 36px; font-size: 22px; line-height: 1;',
    '  color: #64748b; cursor: pointer;',
    '  display: flex; align-items: center; justify-content: center;',
    '  transition: all 0.2s;',
    '}',
    '#tf-exit-close:hover { background: #e2e8f0; color: #334155; }',
    '',
    '.tf-exit-icon { font-size: 48px; margin-bottom: 12px; }',
    '',
    '#tf-exit-popup h2 {',
    '  font-family: "Inter", system-ui, sans-serif !important;',
    '  font-size: 24px !important; font-weight: 800 !important;',
    '  color: #0a3d5c !important; margin: 0 0 10px !important;',
    '  letter-spacing: -0.02em !important; line-height: 1.2 !important;',
    '}',
    '#tf-exit-popup p {',
    '  font-family: "Inter", system-ui, sans-serif !important;',
    '  font-size: 15px !important; color: #64748b !important;',
    '  line-height: 1.6 !important; margin: 0 0 24px !important;',
    '  font-weight: 400 !important;',
    '}',
    '',
    '.tf-exit-buttons {',
    '  display: flex; gap: 12px; justify-content: center;',
    '}',
    '.tf-exit-btn {',
    '  font-family: "Inter", system-ui, sans-serif !important;',
    '  padding: 14px 28px; border-radius: 12px; font-size: 15px;',
    '  font-weight: 600; cursor: pointer; border: none;',
    '  transition: all 0.2s ease; flex: 1;',
    '}',
    '.tf-exit-btn--primary {',
    '  background: #00BADB; color: #fff;',
    '  box-shadow: 0 4px 14px rgba(0,186,219,0.35);',
    '}',
    '.tf-exit-btn--primary:hover {',
    '  background: #0a3d5c; transform: translateY(-1px);',
    '  box-shadow: 0 6px 20px rgba(0,186,219,0.45);',
    '}',
    '.tf-exit-btn--secondary {',
    '  background: #f1f5f9; color: #475569;',
    '}',
    '.tf-exit-btn--secondary:hover {',
    '  background: #e2e8f0; color: #334155;',
    '}',
    '',
    '.tf-exit-note {',
    '  display: block; margin-top: 14px;',
    '  font-family: "Inter", system-ui, sans-serif !important;',
    '  font-size: 12px; color: #94a3b8; font-weight: 500;',
    '}',
    '',
    '@media (max-width: 480px) {',
    '  #tf-exit-popup { padding: 32px 24px 24px; }',
    '  #tf-exit-popup h2 { font-size: 20px !important; }',
    '  .tf-exit-buttons { flex-direction: column-reverse; }',
    '  .tf-exit-icon { font-size: 40px; }',
    '}'
  ].join('\n');
  document.head.appendChild(style);

})();
